import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './LinkButton.module.scss';

const LinkButton = ({
  isError,
  id,
  onClick,
  linkText,
  isBold,
}) => (
  <button
    id={id}
    type="button"
    className={classnames(
      [isError ? styles['error-link'] : styles['button-link']],
      [styles['link-button']],
      [isBold ? styles['bold-btn'] : ''],
    )}
    onClick={onClick}
  >
    {linkText}
  </button>
);

LinkButton.propTypes = {
  isError: PropTypes.bool,
  isBold: PropTypes.bool,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  linkText: PropTypes.string.isRequired,
};
LinkButton.defaultProps = {
  isError: false,
  isBold: false,
};

export default LinkButton;
